import {EditOutlined} from '@mui/icons-material'
import DeleteIcon from '@mui/icons-material/DeleteForever'
import {Dialog, DialogTitle, DialogContent, Typography, Box, Button} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {COMMON_SHIFT_EVENT_WIDGET_NAMESPACE} from '../consts'

type Props = {
  open: boolean
  onCancel: () => void
  onConfirm: () => void
}

export const ConfirmCloseDialog: React.FC<Props> = ({open, onCancel, onConfirm}) => {
  const {t} = useTranslation(COMMON_SHIFT_EVENT_WIDGET_NAMESPACE)

  return (
    <Dialog open={open} onClose={onCancel} data-test-id="confirm-close-dialog">
      <DialogTitle>
        <Typography variant="h2">{t('confirmCloseDialog.unsavedChangesTitle')}</Typography>
      </DialogTitle>
      <DialogContent>
        <Typography>{t('confirmCloseDialog.message.unsavedChangesContent')}</Typography>
        <Box mt={2} display="flex" justifyContent="flex-end" gap={2}>
          <Button
            onClick={onConfirm}
            color="error"
            variant="text"
            startIcon={<DeleteIcon />}
            data-test-id="discard-changes-button"
          >
            {t('confirmCloseDialog.action.discardChanges')}
          </Button>
          <Button
            onClick={onCancel}
            color="primary"
            variant="contained"
            startIcon={<EditOutlined />}
            data-test-id="keep-editing-button"
          >
            {t('confirmCloseDialog.action.keepEditing')}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  )
}
